<script lang="ts">
	export let loaderColor = '#fff',
		classes = '';
</script>

<div
	style="background-color:{loaderColor}"
	class="loader aspect-square rounded-full p-0.5 {classes}"
></div>

<style>
	.loader {
		--_m: conic-gradient(#0000, #000), linear-gradient(#000 0 0) content-box;
		-webkit-mask: var(--_m);
		mask: var(--_m);
		-webkit-mask-composite: source-out;
		mask-composite: subtract;
		box-sizing: border-box;
		animation: load 1s linear infinite;
	}

	@keyframes load {
		to {
			transform: rotate(1turn);
		}
	}
</style>
